// @flow
// @global EpsonBridge

import Order from 'PMT/entities/order/Order';
import Restaurant from 'PMT/entities/Restaurant';

import EpsonPrinter from './printers/EsponPrinter';
import _ from 'lodash';

/**
 * This class allow us to interact with the BO mobile app. Those mobile app allow us to use
 * native functions by using an interface defined on the mobile app.
 */
class MobileAppInteractor {

  static haveEpsonBridge(): boolean {
    return typeof(EpsonBridge) !== 'undefined';
  }

  static printerIsAvailable(): boolean {
    if (!this.haveEpsonBridge()) {
      return false;
    }
    return EpsonBridge.isPrinterConnected();
  }

  static print(content: string) {
    if (this.haveEpsonBridge()) {
      EpsonBridge.print(content);
    }
  }

  static printOrder(order: Order, restaurant: Restaurant): message {
    // if (!this.haveEpsonBridge()) {
    //   return ;
    // }

    const epsonPrinter = new EpsonPrinter();
    const message = epsonPrinter.formatOrderTicket(order, restaurant);

    this.print(message);

    return message;
  }

}

export default MobileAppInteractor;
